import React from "react";
import { statusLabel } from "./teacherMocksHelpers";
import MockActionsMenu from "./MockActionsMenu";

export default function TeacherMockCard({ mock, onToggleEnabled, isToggling, onOpenLink, onView, onCopy, onRanking }) {
  const answeredLabel = mock.totalStudents ? `${mock.answered}/${mock.totalStudents}` : String(mock.answered);

  return (
    <article className="tprof-mobile-card">
      <div className="tprof-mobile-top">
        <div className="tprof-mobile-top-left">
          <div className="tprof-sim-name tprof-sim-name-card">{mock.name}</div>
          <div className="tprof-course">{mock.course}</div>
        </div>
        <div className="tprof-mobile-top-right">
          <span className={`tprof-badge tprof-badge-${mock.status}`}>
            {statusLabel(mock.status)}
          </span>
          <MockActionsMenu
            mock={mock}
            onToggleEnabled={onToggleEnabled}
            isToggling={isToggling}
            onOpenLink={onOpenLink}
            onView={onView}
            onCopy={onCopy}
            onRanking={onRanking}
          />
        </div>
      </div>
      <div className="tprof-mobile-grid">
        <div><span className="tprof-mobile-label">ID</span><span className="tprof-mobile-value">{mock.id}</span></div>
        <div><span className="tprof-mobile-label">Criado em</span><span className="tprof-mobile-value">{mock.createdAt}</span></div>
        <div><span className="tprof-mobile-label">Questões</span><span className="tprof-mobile-value">{mock.questions}</span></div>
        <div><span className="tprof-mobile-label">Responderam</span><span className="tprof-mobile-value">{answeredLabel}</span></div>
        <div><span className="tprof-mobile-label">Média</span><span className="tprof-mobile-value">{mock.average}/{mock.questions}</span></div>
        <div><span className="tprof-mobile-label">Tempo médio</span><span className="tprof-mobile-value">{mock.duration}</span></div>
      </div>
    </article>
  );
}
